// Theme: blueprint-blackboard
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'blueprint-blackboard',
  name: 'BLUEPRINT BLACKBOARD',
  tagline: 'BLUEPRINT BLACKBOARD',
  description: 'Blackboard de engenheiro. Ciano tecnico sobre fundo ardosia profunda.',
  category: 'alternate-modes',
  tier: 'rare',
  basePrice: 2625,
  swatches: ['#0A1520', '#0EA5E9', '#102030', '#E0F0FF'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '10px',
      '--shadow-card': '0 10px 28px rgba(14, 165, 233, 0.14)',
      '--shadow-card-active': '0 10px 28px rgba(14, 165, 233, 0.20)'
    },
    shellClasses: 'font-sans theme-blueprint-blackboard'
  },
  colorVars: {
    '--accent': '#0EA5E9',
    '--accent-foreground': '#0A1520',
    '--background': '#0A1520',
    '--border': '#2A5A8F',
    '--card': '#102030',
    '--card-border-active': 'rgba(14, 165, 233, 0.26)',
    '--card-completed': '#173047',
    '--card-foreground': '#E0F0FF',
    '--card-glow': 'rgba(14, 165, 233, 0.14)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0A1520',
    '--foreground': '#E0F0FF',
    '--hold-fill': '#0EA5E9',
    '--input': '#102030',
    '--modal-bg': '#0A1520',
    '--modal-border': '#2A5A8F',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 10px 28px rgba(14, 165, 233, 0.14)',
    '--muted': '#2A5A8F',
    '--muted-foreground': '#9EC4E8',
    '--nav-active': '#0EA5E9',
    '--nav-bg': '#0A1520',
    '--popover': '#102030',
    '--popover-foreground': '#E0F0FF',
    '--primary': '#0EA5E9',
    '--primary-foreground': '#0A1520',
    '--ring': '#0EA5E9',
    '--secondary': '#2A5A8F',
    '--secondary-foreground': '#E0F0FF',
    '--streak': '#0EA5E9',
    '--success': '#22c55e',
    '--success-foreground': '#0A1520',
    '--xp': '#0EA5E9',
    '--xp-bg': '#102030'
  },
  resolvedVars: {
    '--accent': '#0EA5E9',
    '--accent-foreground': '#0A1520',
    '--accent-foreground-hsl': '210 52% 8%',
    '--accent-foreground-oklch': 'from #0A1520 l c h',
    '--accent-hsl': '199 89% 48%',
    '--accent-oklch': 'from #0EA5E9 l c h',
    '--background': '#0A1520',
    '--background-hsl': '210 52% 8%',
    '--background-oklch': 'from #0A1520 l c h',
    '--border': '#2A5A8F',
    '--border-hsl': '211 55% 36%',
    '--border-oklch': 'from #2A5A8F l c h',
    '--border-w': '1px',
    '--card': '#102030',
    '--card-border-active': 'rgba(14, 165, 233, 0.26)',
    '--card-completed': '#173047',
    '--card-completed-hsl': '209 51% 18%',
    '--card-completed-oklch': 'from #173047 l c h',
    '--card-foreground': '#E0F0FF',
    '--card-foreground-hsl': '209 100% 94%',
    '--card-foreground-oklch': 'from #E0F0FF l c h',
    '--card-glow': 'rgba(14, 165, 233, 0.14)',
    '--card-hsl': '210 50% 13%',
    '--card-oklch': 'from #102030 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0A1520',
    '--destructive-foreground-hsl': '210 52% 8%',
    '--destructive-foreground-oklch': 'from #0A1520 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#E0F0FF',
    '--foreground-hsl': '209 100% 94%',
    '--foreground-oklch': 'from #E0F0FF l c h',
    '--hold-fill': '#0EA5E9',
    '--hold-fill-hsl': '199 89% 48%',
    '--hold-fill-oklch': 'from #0EA5E9 l c h',
    '--input': '#102030',
    '--input-hsl': '210 50% 13%',
    '--input-oklch': 'from #102030 l c h',
    '--modal-bg': '#0A1520',
    '--modal-bg-hsl': '210 52% 8%',
    '--modal-bg-oklch': 'from #0A1520 l c h',
    '--modal-border': '#2A5A8F',
    '--modal-border-hsl': '211 55% 36%',
    '--modal-border-oklch': 'from #2A5A8F l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 10px 28px rgba(14, 165, 233, 0.14)',
    '--muted': '#2A5A8F',
    '--muted-foreground': '#9EC4E8',
    '--muted-foreground-hsl': '209 62% 76%',
    '--muted-foreground-oklch': 'from #9EC4E8 l c h',
    '--muted-hsl': '211 55% 36%',
    '--muted-oklch': 'from #2A5A8F l c h',
    '--nav-active': '#0EA5E9',
    '--nav-active-hsl': '199 89% 48%',
    '--nav-active-oklch': 'from #0EA5E9 l c h',
    '--nav-bg': '#0A1520',
    '--nav-bg-hsl': '210 52% 8%',
    '--nav-bg-oklch': 'from #0A1520 l c h',
    '--popover': '#102030',
    '--popover-foreground': '#E0F0FF',
    '--popover-foreground-hsl': '209 100% 94%',
    '--popover-foreground-oklch': 'from #E0F0FF l c h',
    '--popover-hsl': '210 50% 13%',
    '--popover-oklch': 'from #102030 l c h',
    '--primary': '#0EA5E9',
    '--primary-foreground': '#0A1520',
    '--primary-foreground-hsl': '210 52% 8%',
    '--primary-foreground-oklch': 'from #0A1520 l c h',
    '--primary-hsl': '199 89% 48%',
    '--primary-oklch': 'from #0EA5E9 l c h',
    '--radius': '10px',
    '--ring': '#0EA5E9',
    '--ring-hsl': '199 89% 48%',
    '--ring-oklch': 'from #0EA5E9 l c h',
    '--secondary': '#2A5A8F',
    '--secondary-foreground': '#E0F0FF',
    '--secondary-foreground-hsl': '209 100% 94%',
    '--secondary-foreground-oklch': 'from #E0F0FF l c h',
    '--secondary-hsl': '211 55% 36%',
    '--secondary-oklch': 'from #2A5A8F l c h',
    '--shadow-card': '0 10px 28px rgba(14, 165, 233, 0.14)',
    '--shadow-card-active': '0 10px 28px rgba(14, 165, 233, 0.20)',
    '--streak': '#0EA5E9',
    '--streak-hsl': '199 89% 48%',
    '--streak-oklch': 'from #0EA5E9 l c h',
    '--success': '#22c55e',
    '--success-foreground': '#0A1520',
    '--success-foreground-hsl': '210 52% 8%',
    '--success-foreground-oklch': 'from #0A1520 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(199 89% 48% / 0.15)',
    '--xp': '#0EA5E9',
    '--xp-bg': '#102030',
    '--xp-bg-hsl': '210 50% 13%',
    '--xp-bg-oklch': 'from #102030 l c h',
    '--xp-hsl': '199 89% 48%',
    '--xp-oklch': 'from #0EA5E9 l c h'
  }
}
